import { ChangeDetectionStrategy, Component } from '@angular/core';
import { untranslatedString } from 'models/translated-string';
import { ModelOption } from 'services/scan-config';

// The Scanner Parts card's body on the Test UI Components page (#6020): the scanner screens' hints,
// model picker, photo reel, shutter bar, analyzing overlay and blocked-camera panel, with no camera.
@Component({
  selector: 'cs-test-scanner-parts-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-scanner-parts-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestScannerPartsCardComponent {
  readonly scannerHints: (() => string)[] = [() => 'Use good light', () => 'Hold the phone steady'];
  readonly scannerModels: ModelOption[] = [
    { key: 'fast', label: untranslatedString('Fast') },
    { key: 'accurate', label: untranslatedString('Accurate') },
  ];
  scannerModel = 'fast';
  readonly samplePhotos = [{ dataUrl: 'assets/imgs/default-avatar.jpg' }, { dataUrl: 'assets/imgs/Skinfold-M-Chest.svg' }];
}
